$(function () {
  router.start({
    view: "#app",
    router: {
      // "/home/fund-f10/fundNews": {
      //   templateUrl: "./pages/home/home.html",
      //   controller: "./pages/home/home.js",
      //   styles: "./pages/home/home.css",
      //   animate: "",
      // },
      "/home/fund-f10/fundNews": {
        templateUrl: "./pages/fundNews/fundNews.html",
        controller: "./pages/fundNews//fundNews.js",
        styles: "./pages/fundNews/fundNews.css",
      },
      "/home/fund-f10/fundOverview": {
        templateUrl: "./pages/fundOverview/fundOverview.html",
        controller: "./pages/fundOverview//fundOverview.js",
        styles: "./pages/fundOverview/fundOverview.css",
      },
      "/home/fund-f10/fundManager": {
        templateUrl: "./pages/fundManager/fundManager.html",
        controller: "./pages/fundManager/fundManager.js",
        styles: "./pages/fundManager/fundManager.css",
      },
      "/home/fund-f10/fundCompany": {
        templateUrl: "./pages/fundCompany/fundCompany.html",
        controller: "./pages/fundCompany/fundCompany.js",
        styles: "./pages/fundCompany/fundCompany.css",
      },
      "/home/fund-f10/fundHold": {
        templateUrl: "./pages/fundHold/fundHold.html",
        controller: "./pages/fundHold/fundHold.js",
        styles: "./pages/fundHold/fundHold.css",
      },
      "/home/fund-f10/fundScale": {
        templateUrl: "./pages/fundScale/fundScale.html",
        controller: "./pages/fundScale/fundScale.js",
        styles: "./pages/fundScale/fundScale.css",
      },
      "/home/fund-f10/fundAnnouncement": {
        templateUrl: "./pages/fundAnnouncement/fundAnnouncement.html",
        controller: "./pages/fundAnnouncement/fundAnnouncement.js",
        styles: "./pages/fundAnnouncement/fundAnnouncement.css",
      },
      "/home/fund-f10/fundlist": {
        templateUrl: "./pages/list/list.html",
        controller: "./pages/list/list.js",
        styles: "./pages/list/list.css",
      },
      defaults: "/home/fund-f10/fundlist", //默认路由
    },
  });
});



// WEBPACK FOOTER //
// ./src/router.js